import { Pagination } from 'antd';
import { PaginationProps } from 'antd/lib';
import useMember from 'hooks/useMember';
import debounce from 'lodash.debounce';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NESTEDROUTE from 'utils/router';

const HolidayTable = () => {
  const { filterHolidayCalendar } = useMember();
  const navigate = useNavigate();
  const searchRef = useRef();
  const [state, setState] = useState({
    name: null,
    page: '1',
    page_size: '10',
    holidayFilter: [],
    count: null,
    currentPage: 1,
  });

  const { name, page, page_size, holidayFilter, count, currentPage } = state;

  const onChangeInput = (event) => {
    updateSearchValue(event.currentTarget.value);
  };
  const updateSearchValue = useCallback(
    debounce((event) => {
      setState((pre) => ({
        ...pre,
        name: event,
        page: '1',
      }));
    }, 500),
    [],
  );

  useEffect(() => {
    filterHolidayCalendar({
      ...(name && { name: name }),
      ...(page && { page: page }),
      ...(page_size && { page_size: page_size }),
    }).then((res) => {
      setState((pre) => ({
        ...pre,
        holidayFilter: res?.results,
        count: res?.count,
        currentPage: res?.page,
      }));
    });
  }, [name, page]);

  const itemRender: PaginationProps['itemRender'] = (
    _,
    type,
    originalElement,
  ) => {
    if (type === 'prev') {
      return <a className="mr-3">Previous</a>;
    }
    if (type === 'next') {
      return <a className="mr-3">Next</a>;
    }

    return originalElement;
  };
  const onChange = (pageNumber) => {
    setState((pre) => ({
      ...pre,
      page: pageNumber,
    }));
  };

  return (
    <div>
      <div
        style={{
          padding: '15px 25px 15px 32px',
          borderBottom: '0.5px solid #73A1E7',
        }}
      >
        <span style={{ fontWeight: 600, fontSize: 16, color: '#000000' }}>
          List of managed calendars
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          gap: 20,
          width: '100%',
          borderBottom: '0.5px solid #73A1E7',
          height: 70,
          paddingBottom: 10,
        }}
      >
        <div style={{ width: '20%' }}></div>
        <div
          style={{
            width: '80%',
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '7px',
          }}
        >
          <div style={{ color: '#000000', fontWeight: 600, fontSize: 14 }}>
            Calendar
          </div>
          <input
            maxLength={60}
            ref={searchRef}
            onChange={onChangeInput}
            style={{ marginTop: '2px', width: '60%', color: '#000' }}
            className="common_custom_input_search"
          />
        </div>
      </div>
      {holidayFilter?.length > 0 ? (
        holidayFilter?.map((item: any, index: number) => (
          <div
            className="hoverCell"
            onClick={() => {
              navigate(NESTEDROUTE.staff_leave_holiday_detail, {
                state: { item: item },
              });
            }}
            style={{
              display: 'flex',
              gap: 20,
              width: '100%',
              borderBottom: '0.5px solid #73A1E7',
              height: 60,
              alignItems: 'center',
            }}
          >
            <div
              style={{
                width: '20%',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <img alt="ss" src="/icons/holiday_settings.svg" />
            </div>
            <div
              style={{
                width: '80%',
                color: '#000000',
                fontSize: '12px',
              }}
            >
              {item.name}
            </div>
          </div>
        ))
      ) : (
        <p style={{ textAlign: 'center', color: '#E4E4E4', marginTop: 20 }}>
          No item
        </p>
      )}
      {holidayFilter?.length > 0 && (
        <div className="is-flex is-justify-content-center is-align-content-center mt-2 staff_leave_footer">
          <Pagination
            showSizeChanger={false}
            itemRender={itemRender}
            defaultPageSize={10}
            onChange={onChange}
            defaultCurrent={1}
            total={count}
            current={currentPage}
          />
        </div>
      )}
    </div>
  );
};

export default HolidayTable;
